import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { Link } from 'react-router';
import '../../../stylesheets/pages/preauth/components/FaqAccordion.less';
import HomepageFormV2 from '../../manage/website/entities/HomepageFormV2';
import WeddingInfoFormv2 from '../../manage/website/entities/WeddingInfoFormv2';


class homepageAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: undefined
    };
    this.activeItem = this.activeItem.bind(this);
  }

  activeItem(idx) {
    this.setState({
      selectedItem: this.state.selectedItem === idx ? undefined : idx
    });
  }

  // TODO: is it possible to redo all of the form pages to funnel through here?
  // need to be able to pass the form componen itself through though so you can sniff for dirt (lololol) when needed.


  render() {
    const { evaluateHomeForDirt } = this.props;
    const { selectedItem } = this.state;
    const production = window.zola.env === 'production';

    return (
      <div>
        <div className="accordion">
          <div className={`accordion-section ${selectedItem === 1 ? 'selected' : ''}`}>
            <h4 className={production ? '' : 'form-heading'} onClick={() => this.activeItem(1)} role="button">
              <span>Wedding Summary</span>
              <span className="pull-right">
                <i className={`zolaicon-public ${selectedItem === 1 ? 'zolaicon-public-minus' : 'zolaicon-public-plus'}`} />
              </span>
            </h4>
            <div className="accordion-body">
              <WeddingInfoFormv2 evaluateHomeForDirt={evaluateHomeForDirt} />
            </div>
          </div>
        </div>
        <div className="accordion">
          <div className={`accordion-section ${selectedItem === 2 ? 'selected' : ''}`}>
            <h4 className={production ? '' : 'form-heading'} onClick={() => this.activeItem(2)} role="button">
              <span>Page Header & Footer</span>
              <span className="pull-right">
                <i className={`zolaicon-public ${selectedItem === 2 ? 'zolaicon-public-minus' : 'zolaicon-public-plus'}`} />
              </span>
            </h4>
            <div className="accordion-body">
              <HomepageFormV2 evaluateHomeForDirt={evaluateHomeForDirt} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

homepageAccordion.propTypes = {
  evaluateHomeForDirt: PropTypes.func
};

export default homepageAccordion;



/** WEBPACK FOOTER **
 ** ./src/components/common/ui/homepageAccordion.jsx
 **/